export const mockProductDate = {
  productLabel: "Product",
  productValue:
    "Sugarbear Hair Vitamins - Biotin, Zinc, Iodine, Vitamin E, Folic Acid, Inositol - Vegan Gummies for Hair and Nails, Supplement for Women & Men (1 Month Supply + Bonus Gift)",
  calendarTitle: "Date",
};
